import { Routes, Route } from "react-router-dom";
import HomePage from "../pages/hompage/HomePage";
import PrivateRoute from "../components/PrivateRouter";
import HomeAdmin from "../pages/Admin/HomeAdmin";
import Login from "../pages/login/Login";
import HomeCasino from "../pages/casino/HomeCasino";
import DetailThuthuat from "../pages/casino/DetailThuthuat";
import MainGameBacarat from "../pages/casino/MainGameBacarat"

const Approuter = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/*"
        element={
          <PrivateRoute>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/casino" element={<MainGameBacarat />} />
              <Route path="/trickBacarat" element={<HomeCasino />} />
              <Route path="/trickBacarat/:id" element={<DetailThuthuat />} />
              <Route path="/admin" element={<HomeAdmin />} />
            </Routes>
          </PrivateRoute>
        }
      />

    </Routes>
  );
};

export default Approuter;
